export const state = () => ({
  session_signin_cellphone: '',
  app_live_callers: '',
  app_live_stream_type:'',
})

export const mutations = {
  setSessionSigninCellphone(state,cellphone){
    state.session_signin_cellphone = cellphone
  },
  setAppLiveCallers(state,live_callers){
    state.app_live_callers = live_callers
  },
  setAppLiveStreamType(state,live_stream_type){
    state.app_live_stream_type = live_stream_type
  }
}
